'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility.js');

var _functional_utility2 = _interopRequireDefault(_functional_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RiskIndicatorCard = function (_React$Component) {
  _inherits(RiskIndicatorCard, _React$Component);

  function RiskIndicatorCard(props) {
    _classCallCheck(this, RiskIndicatorCard);

    return _possibleConstructorReturn(this, (RiskIndicatorCard.__proto__ || Object.getPrototypeOf(RiskIndicatorCard)).call(this, props));
  }

  _createClass(RiskIndicatorCard, [{
    key: 'renderRiskIndicator',
    value: function renderRiskIndicator(riskIndicatorValue) {
      return _react2.default.createElement(
        'div',
        { className: 'container width-percent-100 padding-all-0 margin-top-30',
          style: { "text-align": "center" } },
        _react2.default.createElement(
          'div',
          { className: 'row row-equal padding-all-0 margin-horizontal-0' },
          _react2.default.createElement(
            'a',
            { target: '_blank', href: 'https://www.afm.nl/ebi', 'data-testid': 'risk-indicator-link' },
            _react2.default.createElement('img', {
              src: this.props.gaiaRedirectUrl + '/images/AFM_rond_risicoscore' + riskIndicatorValue + '.jpg',
              'data-testid': 'risk-indicator-image',
              className: 'margin-bottom-15',
              style: { "max-height": "280px", "max-width": "280px" } })
          )
        )
      );
    }
  }, {
    key: 'renderSimplifiedRiskIndicator',
    value: function renderSimplifiedRiskIndicator(riskIndicatorValue) {

      var indicatorRange = [1, 2, 3, 4, 5, 6, 7];

      return _react2.default.createElement(
        'div',
        { className: 'category', 'data-testid': 'risk-indicator-summary-text' },
        _string_utility2.default.renderFormattedLabel("default risk indicator text", "pdp-overview-risk-indicator-text", { priipsHoldingPeriod: this.props.priipsHoldingPeriod }),
        _react2.default.createElement(
          'div',
          { className: 'container risk-indicator-table width-percent-100 padding-all-0' },
          _react2.default.createElement(
            'div',
            { className: 'padding-all-0 margin-top-30 margin-bottom-10',
              style: { "text-align": "center" } },
            _react2.default.createElement(
              'div',
              { className: 'row seven-cols row-equal padding-all-0 margin-horizontal-0' },
              indicatorRange.map(function (indicatorValue) {
                return _react2.default.createElement(
                  'div',
                  { 'data-testid': 'risk-indicator-value-cell', className: 'col-md-1 col-sm-1 col-xs-1 col-lg-1 col-xlg-1' + (indicatorValue === riskIndicatorValue ? ' dark-blue-circular-background' : '') },
                  _react2.default.createElement(
                    'div',
                    { className: 'tag risk-indicator-value' },
                    indicatorValue
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row line-container margin-bottom-20' },
            _react2.default.createElement('span', { className: 'line' })
          ),
          _react2.default.createElement(
            'div',
            { className: "row font-13" },
            _react2.default.createElement(
              'div',
              { className: 'col-md-5 col-sm-5 col-xs-5 col-lg-5 col-xlg-5 disclaimer', 'data-testid': 'risk-indicator-low-risk-text' },
              _string_utility2.default.renderFormattedLabel("Lower risk/ potential reward Not risk-free", "pdp-overview-risk-indicator-text-left")
            ),
            _react2.default.createElement('div', { className: 'col-md-2 col-sm-2 col-xs-2 col-lg-2 col-xlg-2' }),
            _react2.default.createElement(
              'div',
              { className: 'col-md-5 col-sm-5 col-xs-5 col-lg-5 col-xlg-5 text-right disclaimer', 'data-testid': 'risk-indicator-high-risk-text' },
              _string_utility2.default.renderFormattedLabel("Higher risk/potential reward", "pdp-overview-risk-indicator-text-right")
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _card_component2.default,
        {
          headerTitle: _string_utility2.default.renderFormattedLabel("Risk indicator", "pdp-overview-risk-indicator"),
          headerTitleId: "riskIndicatorCardHeaderId",
          headerTitleLabel: "",
          breakpoint: this.props.breakpoint,
          headerLabel: "",
          dataTest: 'risk-indicator-card',
          style: _functional_utility2.default.ifMobileBreakpoint(this.props.breakpoint, { "padding-left": "16px", "padding-right": "16px" }, {}),
          disclosureText: this.props.disclosure,
          placementId: 'pdpCardRiskIndicatorBelgium',
          shouldAlwaysShowMore: this.props.shouldAlwaysShowMore
        },
        this.props.simplifiedView ? this.renderSimplifiedRiskIndicator(this.props.riskIndicatorValue) : this.renderRiskIndicator(this.props.riskIndicatorValue)
      );
    }
  }]);

  return RiskIndicatorCard;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(RiskIndicatorCard, { withRef: true });